export default __webpack_public_path__ + "static/media/Bracers of Vehement Thunder.a782838b.jpg";